import { render, staticRenderFns } from "./QC.vue?vue&type=template&id=26b9e86c&scoped=true&"
import script from "./QC.ts?vue&type=script&lang=js&"
export * from "./QC.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b9e86c",
  null
  
)

export default component.exports